import React from 'react';

import {
  TextField,
} from '@mui/material';
import { Controller } from 'react-hook-form';

// @ts-ignore
const getError = (error: any, items: string[]) => {
  if (error) {
    const key = items.shift();
    if (key) {
      return getError(error[key], items);
    }
    return error;
  }
  return undefined;
};

/**
 * プロパティ
 */
export type Props = {
  /** 名前 */
  name: string,
  /** ラベル */
  label: string,
  /** ルール */
  rules: any,
  /** エラー */
  errors: any,
  /** コントロール */
  control: any,
  /** 種別 */
  type: React.HTMLInputTypeAttribute,
  /** Place Holder */
  placeholder: string,
  /** 無効化 */
  disabled?: boolean,
  /** ステップ */
  step?: string,
  /** 複数行 */
  multiline?: boolean,
  /** 行 */
  rows?: string | number,
}

const TextFieldComp: React.FC<Props> = ({
  type,
  control,
  rules,
  name,
  label,
  errors,
  placeholder,
  disabled = false,
  step = undefined,
  multiline = false,
  rows = undefined,
}) => {
  const error = getError(errors, name.split('.'));
  return (
    <div style={{ margin: '10px 0' }}>
      <Controller
        render={
          ({ field }) => (
            <TextField
              label={label}
              variant="outlined"
              value={field.value}
              onChange={field.onChange}
              placeholder={placeholder}
              type={type}
              fullWidth
              error={error !== undefined}
              helperText={error && error.message}
              disabled={disabled}
              multiline={multiline}
              rows={rows}
              inputProps={step ? {
                step,
              } : undefined}
            />
          )
        }
        name={name}
        control={control}
        rules={rules}
      />
    </div>
  );
};

export default TextFieldComp;
